import type { ReactNode } from 'react';

import { cn } from '@infinex/ui-styles';
import { Pressable } from '@infinex/ui/components';

type AssetListItemPressableProps = {
  children: ReactNode;
  onPress: () => void;
  isDisabled?: boolean;
  isSelected?: boolean;
  highlightSelected?: boolean;
  className?: string;
  'data-testid'?: string;
  'aria-label'?: string;
  'aria-pressed'?: boolean;
};

export function AssetListItemPressable({
  children,
  isSelected,
  highlightSelected,
  isDisabled,
  className,
  ...props
}: AssetListItemPressableProps) {
  return (
    <Pressable
      {...props}
      isDisabled={isDisabled}
      className={cn(
        'bg-canvas pressed:bg-surfacePress hover:bg-surfaceHover',
        'focus-visible:outline-focusRing outline-hidden',
        'flex w-full items-center justify-between rounded-2xl px-4 py-3.5',
        highlightSelected && isSelected && 'ring-2',
        isDisabled && 'cursor-not-allowed',
        className
      )}
    >
      {children}
    </Pressable>
  );
}
